// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e_vA","scoreRing":"e_wA","badge":"e_xA","badgeImage":"e_yA","spaced":"e_zA"};